import React, { Component } from "react";
import injectSheet from "react-jss";
// import Color from 'color'
import { withRouter, Link, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { palette } from "../../Theme/Theme";
import * as Actions from "../../Actions/Actions";
import logo from "../../../assets/spectiv_color.png";
// import ReactGA from 'react-ga'
import Responsive from "react-responsive";
import { isMobile } from "react-device-detect";

const Desktop = props => <Responsive {...props} minWidth={1021} />;
// const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={1299} />
const Mobile = props => <Responsive {...props} maxWidth={1020} />;

const mapStateToProps = state => {
  return {};
};

class HomeHeader extends Component {
  constructor() {
    super();
    this.toggleSideNav = this.toggleSideNav.bind(this);
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <div
          style={{ justifyContent: "flex-start" }}
          className={classes.subContainer}
        >
          {this.props.history.location.pathname === "/Home" ? (
            <i
              onClick={this.toggleSideNav}
              style={{ fontSize: isMobile ? '1rem' : "1.5rem" }}
              className={`${classes.navItem} fas fa-bars`}
            />
          ) : null}
        </div>
        <div className={classes.subContainer}>
          <Link to="/">
            <img className={classes.logo} src={logo} alt="" />
          </Link>
        </div>
        <div
          style={{ justifyContent: "flex-end" , marginRight: '1vw'}}
          className={classes.subContainer}
        >
          <NavLink
            // style={{fontSize: isMobile ? '.8rem' : '1.3vw'}}
            activeClassName={classes.navItemActive}
            to="/Home"
            className={classes.navItem}
          >
            Home
          </NavLink>
          <NavLink
            activeClassName={classes.navItemActive}
            to={{ pathname: "/Home/playlists", state: {opacity: '1', playlistOpacity: '0'} }}
            className={classes.navItem}
          >
            Playlists
          </NavLink>
          <NavLink
            activeClassName={classes.navItemActive}
            to="/Home/accountInfo"
            className={classes.navItem}
          >
            Settings
          </NavLink>
          <div
            onClick={this.signOut}
            to="/Home/AccountInfo"
            className={classes.navItem}
          >
            Sign Out
          </div>
        </div>
      </div>
    );
  }

  toggleSideNav() {
    this.props.dispatch({ type: "TOGGLE_SIDE_NAV" });
  }

  signOut = () => {
    const { dispatch, history } = this.props;
    dispatch(Actions.signOut(history));
  };
}

const styles = {
  container: {
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    right: "0",    
    width: "100vw",
    height: "7vh",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&>*": {
      "overflow-y": "hidden"
    }
  },
  subContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    width: "33vw"
  },
  navItem: {
    transition: "all .4s",
    fontSize: "1.3vw",
    margin: "1vw",
    '-webkit-touch-callout': 'none',
    '-webkit-user-select': 'none',
    '-khtml-user-select': 'none',
    '-moz-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
    outline: '0',
    color: palette.white,
    textDecoration: "none",
    "&:hover": {
      color: palette.blue,
      cursor: "pointer"
    }
  },
  logo: {
    width: "12vw",
    minWidth: "6rem"
  }
};

export default withRouter(
  connect(mapStateToProps)(injectSheet(styles)(HomeHeader))
);



// WEBPACK FOOTER //
// ./src/js/Components/Home/HomeHeader.jsx